import _ from "lodash";
import moment from "moment";
import WidgetSkeleton from "./WidgetSkeleton";
import WidgetDataLabel from "./WidgetDataLabel";
import WidgetMessage, { BaseWidgetMessages } from "./WidgetMessage";
import { Card, Col } from "react-bootstrap"
import { ThemedSpan } from "../../../components/utilities";
import { useFeesSummaryData } from "../hooks/FeesSummaryContext";

const WidgetBody = () => {
    const { data, error } = useFeesSummaryData();

    if (error) {
        return <WidgetMessage icon={['fas', 'exclamation']} message={BaseWidgetMessages.Error} />
    }

    if (!data || data.length < 1) {
        return <WidgetMessage message={BaseWidgetMessages.NoResult} />
    }

    const formattedDate = moment(data.reportDate).format('MMMM'); 
    const financialYearStartDate = moment(data.financialYearStartDate).format('MMMM yyyy')
    return (
        <>
            <WidgetDataLabel label={`${formattedDate} fees`} value={data?.monthToDateFees.toLocaleString("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 })} />
            <WidgetDataLabel label={`${formattedDate} in progress`} value={data?.monthWipFees.toLocaleString("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 })} />
            <WidgetDataLabel label={`Forecast for ${formattedDate}`} value={data?.monthForecastFees.toLocaleString("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 })} />
            <WidgetDataLabel label={`Advice fees for year to date`} value={data?.adviceFeesYtd.toLocaleString("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 })} />
            <WidgetDataLabel className="mt-4" label={`${formattedDate} net asset flows`} value={data?.netAssetFlowsMonth.toLocaleString("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 })} />
            <WidgetDataLabel label={`Net asset flows since ${financialYearStartDate}`} value={data?.netAssetFlowsYtd.toLocaleString("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 })} />
        </>
    );
}

export const FeesWidget = () => {
    const { isFetching, isLoading } = useFeesSummaryData();

    if (isFetching || isLoading) {
        return <WidgetSkeleton />
    }

    return (
        <Col xs={12} sm={12} md={6} lg={6} xl={4}>
            <a className="text-reset text-decoration-none" href={"/management/projects"}>
                <Card className="overflow-hidden" style={{ height: "300px", color: "dodgerblue" }}>
                    <Card.Body>
                        <Card.Title className="pb-2" style={{ fontSize: "18px" }}>
                            <ThemedSpan variant="primary" className="fw-bold">Advice Fees</ThemedSpan>
                        </Card.Title>
                        <Card.Text as="div" className="row g-2">
                            <WidgetBody />
                        </Card.Text>
                    </Card.Body>
                </Card>
            </a>
        </Col>
    );
}